import { Component, OnInit } from '@angular/core';
import { RuleBuilderService } from '../../services/rule-builder.service';
import {RuleCompiler} from '../../../flow/services/rule-compiler.service';
import {Rule} from '../../../common/models/flow.dto';
import { LunaCodeError } from '../../../common/models/rules.model';

@Component({
    selector: 'app-expression-test',
    templateUrl: './expression-test.component.html',
    standalone: false
})
export class ExpressionTestComponent implements OnInit {

  constructor(public builder: RuleBuilderService, public compiler: RuleCompiler) { 

    
  }

  public ruleText:string;
  public contextJson:string;
  public result:string;
  ngOnInit() {
  }

  async doTest(){

    let node = await this.builder.compileExpression(this.ruleText).toPromise();
    if(node.hasOwnProperty('message')){
      this.result = (node as LunaCodeError).message;
      return;
    }

    let context:any = null;
    try{
      context = JSON.parse(this.contextJson);
    }
    catch(e){
      this.result = JSON.stringify(e);
      return;
    }

    let rule:Rule = {
      ruleId : "ase", 
      name:"foo",
      expression : this.ruleText,
      parseTree : node 
    };

    let fn: ()=>any = null;
    try{ 
      fn = this.compiler.compileSyncRule<any>(rule, context, {});
    } catch (e) {
      this.result = JSON.stringify(e);
      return;
    }
    try{
      let result = fn();
      this.result = JSON.stringify(result);
    }
    catch (e) {
      this.result = JSON.stringify(e);
      return;
    }

    
  }

}
